import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { SigninPage, SIGNUP_BASES, STEP_PATHS } from '@Pages';

// Every step has its own address under each start page (Vova 29.10.2026): step 1 on the start page itself, where the
// site and the ads link, then setup/ and trial/ under it. The page itself decides which step to show (stepPaths.ts).
export const router = createBrowserRouter([
    ...SIGNUP_BASES.flatMap((base) =>
        Object.values(STEP_PATHS).map((step) => ({ path: base + step, element: <SigninPage /> })),
    ),
    // The success page between the trial step and the account: its own address, so the marketing team can hang
    // pixels and URL conversions on it in GTM.
    {
        path: '/complete/',
        element: <SigninPage />,
    },
]);
